import { Link, Stack } from '@mui/joy';
import { Link as RouterLink } from 'react-router-dom';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLines } from 'core/elements';
import { PricingSourceDiscountType, PricingSourceStatus, PricingSourceType } from 'pricing/enums';
import { PriceSourceHelper } from 'pricing/helpers';
import { IPriceSourceData } from 'pricing/types';
import { Level } from 'theme/enums';

interface IProps {
  priceSource: {
    priceSourceId?: number;
    priceSourceType?: PricingSourceType;
    priceSourceDiscountType?: PricingSourceDiscountType;
    priceQuantityDiscountsApplied?: number;
    priceSourcePricingProfileId?: number;
    priceSourcePricingProfileName?: string;
    priceSourceStatus?: PricingSourceStatus;
  };
}

export const PriceSource = ({ priceSource }: IProps) => {
  const priceSourceLabel = PriceSourceHelper.getTypeLabel(priceSource);

  const priceSourceDiscountTypeLabel = PriceSourceHelper.getDiscountTypeLabel(priceSource);

  const extras = [];
  const quantityDiscountsApplied = PriceSourceHelper.getQuantityDiscountsApplied(priceSource);
  if (quantityDiscountsApplied) {
    extras.push(quantityDiscountsApplied);
  }

  const pricingProfileName = PriceSourceHelper.getPricingProfileName(
    priceSource as IPriceSourceData
  );

  if (pricingProfileName) {
    const pricingProfileUrl = PriceSourceHelper.getPricingProfileUrl(
      priceSource as IPriceSourceData
    );

    extras.push(
      pricingProfileUrl ? (
        <Link level={Level.BODY_XS} component={RouterLink} to={pricingProfileUrl}>
          {pricingProfileName}
        </Link>
      ) : (
        pricingProfileName
      )
    );
  }

  return (
    <Stack gap={0}>
      <TextLines
        texts={[priceSourceLabel || DEFAULT_PLACEHOLDER, priceSourceDiscountTypeLabel].filter(
          (value) => !!value
        )}
        bold
        textEllipsis
      />

      <TextLines texts={[...extras]} isSubText textEllipsis />
    </Stack>
  );
};
